import React from 'react';
import Input from '../../../components/Input/Input';
import PasswordInput from '../../../components/Input/PasswordInput';
import { FaTimes } from 'react-icons/fa';
import './AddSalesModal.css';

const AddEditModal = ({
  showModal,
  isEditMode,
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
  alertMsg,
  saveLoading,
  onSave,
  onClose
}) => {
  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? 'Edit Sales Person' : 'Add Sales Person'}</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
            disabled={saveLoading}
          >
            <FaTimes />
          </button>
        </div>

        <div className="profile-form">
          <Input
            title="Name"
            type="text"
            placeholder="Name"
            value={name}
            onChange={e => setName(e.target.value)}
          />

          <Input
            title="Email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />

          <PasswordInput
            title="Password"
            placeholder={isEditMode ? 'Enter new password' : 'Enter password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          {alertMsg && (
            <div className="modal-alert-dark">{alertMsg}</div>
          )}

          <div className="form-actions">
            <button type="button" onClick={onSave} disabled={saveLoading}>
              {saveLoading ? (
                isEditMode ? 'Updating...' : 'Saving...'
              ) : (
                isEditMode ? 'Update' : 'Save'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditModal; 